/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Connexion\BtnsGroup\BtnsGroup.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Monday December 11th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday December 11th 2023 3:31:24 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { ButtonGroup, Button } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

type BtnsGroupProps = {
    data: {
        name: string,
        text: string,
        icon: JSX.Element,
        status: string,
    }[],
    changeState: Function,
    class?: string,
    selected: number,
}

const BtnsGroup = forwardRef((props: BtnsGroupProps, ref) => {
    const [selected, setSelected] = useState<number>(props.selected);

    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);
    function handleChange(idx: number): void {
        // const newStatus = props.data[idx].status === "desc" ? "asc" : props.data[idx].status === "asc" ? "notActivated" : "desc";
        // newStatus !== "notActivated" ? setSelected(idx) : setSelected(1);
        const newStatus = props.data[idx].status === "desc" ? "asc" : "desc";
        setSelected(idx);
        props.changeState(props.data[idx].name, newStatus);
    };

    return (
        <ButtonGroup className={props.class}>
            {
                props.data.map((val, idx) =>
                    <Button key={Math.random()} variant={selected === idx ? "contained": "outlined"} onClick={() => handleChange(idx)}>{val.text}{val.icon}</Button>
                )
            }
        </ButtonGroup>
    )
})

export default BtnsGroup;
